import { html } from "lit";
import { translate } from "../../../locales";
import { PluginTask } from "../plugin-busy-manager";
import { PluginBusyList } from "./component";

export const template = (props: PluginBusyList) => html`
    <div class="container">
        <div class="title">${translate("busyManager.title")}</div>
        <div class="list">
            ${props.data?.busyTasks?.map(
              (item: PluginTask) => html`
                <div class="plugin-busy-item">
                    <dss-typography tag="div" variant="body-3" fontweight="regular">
                        ${item.taskDescription}
                    </dss-typography>
                </div>`,
            )}
        </div>
    </div>
`;
